import(/* webpackMode: "eager" */ "/chyronic/app/globals.css");
import(/* webpackMode: "eager" */ "/chyronic/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/chyronic/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/chyronic/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/chyronic/components/ui/tooltip.tsx")